import React from "react";
import {BaseContactFormContainer} from "app/contacts/components/BaseContactForm/BaseContactFormContainer";

export const RegistrantContactForm = (props) =>
    <BaseContactFormContainer
        {...props}
        onChangeEntityType={props.onChangeEntityType}
        isRegistrant={true}
    />
